module.exports = require("mdi-material-ui/AccountCircle");